export const state = {
  pending: false,
  isOpen: false,
  selectedDocuments: [],
}
